// Shader Chromakey personalizzato per A-Frame
// Rimuove il colore blu (0.02, 0.08, 0.99) dal video

// Funzione per registrare lo shader in modo lazy
const registerChromakeyShader = () => {
  if (typeof AFRAME === 'undefined') {
    console.warn('⚠️ AFRAME non disponibile per chromakey-shader, riprovo...')
    setTimeout(registerChromakeyShader, 100)
    return
  }
  
  if (AFRAME.shaders && AFRAME.shaders.chromakey) {
    // Shader già registrato (probabilmente dal CDN)
    return
  }
  
  AFRAME.registerShader('chromakey', {
  schema: {
    src: {type: 'map'},
    color: {type: 'vec3', default: {x: 0.02, y: 0.08, z: 0.99}},
    threshold: {type: 'number', default: 0.15},
    smoothness: {type: 'number', default: 0.1}
  },

  init: function (data) {
    // Crea una texture vuota inizialmente
    this.texture = new THREE.Texture();
    
    // Configura la texture per evitare errori WebGL
    this.texture.generateMipmaps = false; // Disabilita mipmap per video
    this.texture.minFilter = THREE.LinearFilter; // Filtro lineare per video
    this.texture.magFilter = THREE.LinearFilter;
    this.texture.format = THREE.RGBAFormat;
    this.texture.type = THREE.UnsignedByteType;
    
    // Gestisce correttamente i valori di colore RGB
    let colorValue;
    if (data.color && typeof data.color === 'object' && data.color.x !== undefined) {
      // Formato vec3: {x: 0.02, y: 0.08, z: 0.99}
      colorValue = new THREE.Vector3(data.color.x, data.color.y, data.color.z);
    } else if (data.color && typeof data.color === 'string') {
      if (data.color.includes(' ')) {
        // Formato legacy: "0.02 0.08 0.99"
        const rgbValues = data.color.split(' ').map(Number);
        if (rgbValues.length === 3 && !rgbValues.some(isNaN)) {
          colorValue = new THREE.Vector3(rgbValues[0], rgbValues[1], rgbValues[2]);
        } else {
          // Fallback se il parsing fallisce
          colorValue = new THREE.Vector3(0.02, 0.08, 0.99);
        }
      } else {
        // Formato stringa hex: "#0416fc"
        colorValue = new THREE.Color(data.color);
      }
    } else {
      // Fallback al colore blu predefinito
      colorValue = new THREE.Vector3(0.02, 0.08, 0.99);
    }
    
    this.material = new THREE.ShaderMaterial({
      uniforms: {
        src: {value: this.texture},
        color: {value: colorValue},
        threshold: {value: data.threshold || 0.15},
        smoothness: {value: data.smoothness || 0.1}
      },
      vertexShader: `
        varying vec2 vUv;
        void main() {
          vUv = uv;
          gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
      `,
      fragmentShader: `
        uniform sampler2D src;
        uniform vec3 color;
        uniform float threshold;
        uniform float smoothness;
        varying vec2 vUv;
        
        void main() {
          vec4 texColor = texture2D(src, vUv);
          
          // Calcola la distanza dal colore chroma
          float dist = distance(texColor.rgb, color);
          
          // Crea una transizione smooth per l'alpha
          float alpha = 1.0 - smoothstep(threshold, threshold + smoothness, dist);
          
          // Se il colore è molto vicino al chroma, rendi trasparente
          if (dist < threshold) {
            discard;
          }
          
          gl_FragColor = vec4(texColor.rgb, alpha);
        }
      `,
      transparent: true,
      side: THREE.DoubleSide
    });
  },

  update: function (data) {
    if (data.src) {
      // Verifica che la texture sia valida prima di aggiornarla
      if (data.src && data.src.image && data.src.image.videoWidth > 0 && data.src.image.videoHeight > 0) {
        this.texture.image = data.src;
        this.texture.needsUpdate = true;
        
        // Aggiorna le dimensioni della texture
        this.texture.image = data.src;
        this.texture.image.needsUpdate = true;
        
        // Forza l'aggiornamento del materiale
        this.material.needsUpdate = true;
      } else {
        // Se la texture non è ancora pronta, aspetta
        if (data.src && data.src.addEventListener) {
          data.src.addEventListener('loadedmetadata', () => {
            if (data.src.videoWidth > 0 && data.src.videoHeight > 0) {
              this.texture.image = data.src;
              this.texture.needsUpdate = true;
              this.material.needsUpdate = true;
            }
          });
        }
      }
    }
    
    if (data.color) {
      let colorValue;
      if (typeof data.color === 'object' && data.color.x !== undefined) {
        // Formato vec3
        colorValue = new THREE.Vector3(data.color.x, data.color.y, data.color.z);
      } else if (typeof data.color === 'string') {
        if (data.color.includes(' ')) {
          // Formato legacy: "0.02 0.08 0.99"
          const rgbValues = data.color.split(' ').map(Number);
          if (rgbValues.length === 3 && !rgbValues.some(isNaN)) {
            colorValue = new THREE.Vector3(rgbValues[0], rgbValues[1], rgbValues[2]);
          } else {
            // Fallback se il parsing fallisce
            colorValue = new THREE.Vector3(0.02, 0.08, 0.99);
          }
        } else {
          // Formato stringa hex
          colorValue = new THREE.Color(data.color);
        }
      } else {
        // Fallback
        colorValue = new THREE.Vector3(0.02, 0.08, 0.99);
      }
      this.material.uniforms.color.value.copy(colorValue);
    }
    
    if (data.threshold !== undefined) {
      this.material.uniforms.threshold.value = data.threshold;
    }
    
    if (data.smoothness !== undefined) {
      this.material.uniforms.smoothness.value = data.smoothness;
    }
  }
  })
  
  console.log('✅ Shader chromakey registrato')
}

// Esporta la funzione invece di eseguirla immediatamente
export {registerChromakeyShader}

// Inizializza quando il DOM è pronto e AFRAME è disponibile (solo se importato direttamente)
// Questo viene eseguito solo se il file viene importato come side-effect
if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerChromakeyShader)
  } else {
    // DOM già pronto, prova subito
    setTimeout(registerChromakeyShader, 100)
  }
} 